module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// /home/markush/Projects/fieldsale-wingman-client/src/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/fonts/glyphicons-halflings-regular.svg
// module chunks = styles